import React from "react"
import { Redirect } from "react-router-dom"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"
import Resetpsw from "pages/Authentication/Resetpsw"
import Compareotp from "pages/Authentication/Compareotp"
import VerifyOtp from "pages/Authentication/VerifyOtp"
import ChangeSecurityPin from "pages/ManageProfile/ChangeSecurityPin"

// Dashboard
import Dashboard from "../pages/Dashboard/index"
import Analytics1 from "pages/Dashboard/Analytics1"
import Analytics2 from "pages/Dashboard/Analytics2"
import Analytics3 from "pages/Dashboard/Analytics3"

// Customers
import CustomerList from "pages/Users/CustomerList"
import ViewCustomer from "pages/Users/ViewCustomer"

// Orders
import AllOrders from "pages/Orders/AllOrders"
import ViewOrder from "pages/Orders/ViewOrder"

// Notifications
import Notifications from "pages/Pages/Notifications"

//Manage-Profile
import UserProfile from "../pages/Authentication/user-profile"
import Addresses from "pages/ManageProfile/Addresses"
import ManagePaymentsAccounts from "pages/ManageProfile/ManagePaymentsAccounts"
import ManagePaymentsMethods from "pages/ManageProfile/ManagePaymentsMethods"

//Manage-Supplier
import AddSeller from "pages/Sellers/AddSeller"
import EditSeller from "pages/Sellers/EditSeller"
import ViewSeller from "pages/Sellers/ViewSeller"
import SellersList from "pages/Sellers/SellersList"

//Manage-Salesman
import SalesmanList from "pages/ManageSalesman/SalesmanList"
import AddSalesman from "pages/ManageSalesman/AddSalesman"
import EditSalesman from "pages/ManageSalesman/EditSalesman"

//Manage-Products
import CreateProduct from "pages/ManageProducts/CreateProduct"
import ViewProduct from "pages/ManageProducts/ViewProduct"
import EditProduct from "pages/ManageProducts/EditProduct"
import Products from "pages/ManageProducts/Products"
import ReceiptAccounts from "pages/ManageProducts/ReceiptAccounts"
import ManageProductVarients from "pages/ManageProducts/ManageProductVarients"

// Manage-Promotions
import AddDeal from "pages/Deals/AddDeal"
import EditDeal from "pages/Deals/EditDeal"
import ViewDeal from "pages/Deals/ViewDeal"
import AddAdvertisements from "pages/Advertisements/AddAdvertisements"
import EditAdvertisements from "pages/Advertisements/EditAdvertisements"
import ViewAdvertisements from "pages/Advertisements/ViewAdvertisements"
import ViewProductVarients from "pages/Deals/ViewProductVarients"
import Deals from "pages/Deals/Deals"
import Advertisements from "pages/Advertisements/Advertisements"
import ProductVarients from "pages/Deals/ProductVarients"

//Manage-security
import ChangePassword from "pages/ManageProfile/ChangePassword"

// Manage-General
import TermsAndConditions from "pages/Pages/TermsAndConditions"
import PrivacyPolicy from "pages/Pages/PrivacyPolicy"
import Terms from "pages/Authentication/Terms"
import Privacy from "pages/Authentication/Privacy"

// AboutUs
import AboutUs from "pages/Pages/AboutUs"
import ContactUs from "pages/Pages/ContactUs"
import FAQ from "pages/Pages/FAQ"

// Help
import SupplierHelp from "pages/Support/SupplierHelp"

import Subscriptions from "pages/Subscriptions/Subscriptions"
import SubscriptionDetails from "pages/Subscriptions/SubscriptionDetails"

const authProtectedRoutes = [
  // Dashboard
  { path: "/dashboard", component: Dashboard },
  { path: "/Analytics1", component: Analytics1 },
  { path: "/Analytics2", component: Analytics2 },
  { path: "/Analytics3", component: Analytics3 },

  // Customers
  { path: "/CustomerList", component: CustomerList },
  { path: "/ViewCustomer", component: ViewCustomer },

  // Orders
  { path: "/AllOrders", component: AllOrders },
  { path: "/ViewOrder", component: ViewOrder },

  // Notifications
  { path: "/notifications", component: Notifications },

  { path: "/Subscriptions", component: Subscriptions },
  { path: "/SubscriptionDetails", component: SubscriptionDetails },

  //Manage-Profile
  { path: "/profile", component: UserProfile },
  { path: "/Addresses", component: Addresses },
  { path: "/managepaymentsaccounts", component: ManagePaymentsAccounts },
  { path: "/ManagePaymentsMethods", component: ManagePaymentsMethods },

  // Manage-Supplier
  { path: "/AddSeller", component: AddSeller },
  { path: "/EditSeller", component: EditSeller },
  { path: "/ViewSeller", component: ViewSeller },
  { path: "/SellersList", component: SellersList },

  // Manage-Salesman
  { path: "/AddSalesman", component: AddSalesman },
  { path: "/SalesmanList", component: SalesmanList },
  { path: "/EditSalesman", component: EditSalesman },

  // Manage-Products
  { path: "/CreateProduct", component: CreateProduct },
  { path: "/Products", component: Products },
  { path: "/ViewProduct", component: ViewProduct },
  { path: "/EditProduct", component: EditProduct },
  { path: "/ManageProductVarients", component: ManageProductVarients },

  // Manage-Recipts
  { path: "/ReceiptAccounts", component: ReceiptAccounts },

  // Manage-Promotions
  { path: "/AddDeal", component: AddDeal },
  { path: "/Deals", component: Deals },
  { path: "/EditDeal", component: EditDeal },
  { path: "/ViewDeal", component: ViewDeal },
  { path: "/AddAdvertisements", component: AddAdvertisements },
  { path: "/EditAdvertisements", component: EditAdvertisements },
  { path: "/ViewAdvertisements", component: ViewAdvertisements },
  { path: "/Advertisements", component: Advertisements },
  { path: "/ProductVarients", component: ProductVarients },
  { path: "/ViewProductVarients", component: ViewProductVarients },

  //Manage-security
  { path: "/ChangePassword", component: ChangePassword },

  // Manage-General
  { path: "/TermsAndConditions", component: TermsAndConditions },
  { path: "/PrivacyPolicy", component: PrivacyPolicy },
  { path: "/ChangeSecurityPin", component: ChangeSecurityPin },

  // AboutUs
  { path: "/AboutUs", component: AboutUs },
  { path: "/ContactUs", component: ContactUs },
  { path: "/FAQ", component: FAQ },

  // Help
  { path: "/SupplierHelp", component: SupplierHelp },

  { path: "/", exact: true, component: () => <Redirect to="/login" /> },
]

const publicRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/register", component: Register },
  { path: "/Resetpsw", component: Resetpsw },
  { path: "/Compareotp", component: Compareotp },
  { path: "/verifyotp", component: VerifyOtp },
  { path: "/Terms", component: Terms },
  { path: "/Privacy", component: Privacy },
]

export { publicRoutes, authProtectedRoutes }
